import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes, defaultAttributes } from './Constants';

import { timeToReadContainer, timerIcon } from './TimeToRead.module.scss';

const TimeToRead = ({ time = defaultAttributes.TIME_LABEL }) => (
    <span className={timeToReadContainer} data-testid={testAttributes.TIMETOREAD_MAIN_CONTAINER}>
        <span className={timerIcon}>{time}</span>
        <span>{defaultAttributes.MIN_READ_LABEL}</span>
    </span>
);

TimeToRead.propTypes = {
    time: PropTypes.string,
};

export default TimeToRead;